<div  class="db-migration-success-dialog">
  <div class="db-migration-success-dialog__website-info" *ngIf="!!isMobile">
    <div>
      <div class="db-migration-success-dialog__preview-thumbnail"
           [ngStyle]="{
               'background-color': 'rgba(0, 0, 0, 0.1)',
               'background-image': 'url(&quot;'+ ('data:image/jpg;base64,' + websiteScreenshot) + '&quot;)',
               'background-size': 'cover'
               }">
      </div>
      <div class="db-migration-success-dialog__preview-site-info">
        <div>
          <p class="db-migration-success-dialog__subtitle">Your website URL</p>
          <a target="_blank" rel="noopener" href="{{siteUrl}}" class="db-migration-success-dialog__link">
            <span [innerHTML]="siteUrl"></span><i class="db-icon db-icon-external-n"></i>
          </a>
        </div>
        <div class="mt20">
          <p class="db-migration-success-dialog__subtitle">Location/data center</p>
          <p class="db-migration-success-dialog__location" [innerText]="hostingInfoData?.hostingBasicInfo?.location"></p>
        </div>
      </div>
    </div>
    <div class="db-migration-success-dialog__fastest" >
      <p>Your website is now in the top<br/> <b>1% fastest websites</b> of the world․</p>
      <img src="assets/images/google/google-partner-transparent.svg" alt="">
    </div>
  </div>


  <div class="db-migration-success-dialog__scores">
    <h1>Copy of your website is live</h1>
    <div class="db-migration-success-dialog__score-grid" [ngClass]="{'mt20': !isMobile, 'mt15': !!isMobile}">
      <div class="db-migration-success-dialog__score-grid-item"><b class="title">Original website</b></div>
      <div class="db-migration-success-dialog__score-grid-item"><b class="title">Copy of your website</b></div>
      <div class="db-migration-success-dialog__score-grid-item score-info" *ngFor="let score of scores">
        <ds-score *ngIf="score?.score" [score]="score?.score" [withShadow]="false" size="m" [lineWidth]="3"></ds-score>
        <div *ngIf="!score?.score" class="no-score">- -</div>
        <div class="db-migration-success-dialog__score-info">
          <b class="score"><span>{{score?.type ? (score?.type + ' score') : '-'}}</span> </b>
          <p class="load-time">Load time: {{score?.time ? (score?.time + 's') : '-'}}</p>
        </div>
      </div>
    </div>
    <div class="db-migration-success-dialog__benefits mt18" [ngClass]="{'mt25': !!isMobile}">
      <h2>Enjoy the benefits of an enhanced load time and PageSpeed score</h2>
      <div class="db-migration-benefits mt10" [ngClass]="{'mt15': !!isMobile}">
        <div>
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i> </p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>Up to 7%</b> increased conversions </p>
        </div>
        <div class="mt8">
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>Up to 40%</b> boost in visitor engagement </p>
        </div>
        <div class="mt8">
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>Up to 53%</b> increase in mobile traffic engagement </p>
        </div>
      </div>
    </div>
    <div class="db-migration-success-dialog__benefits mt18" [ngClass]="{'mt25': !!isMobile}">
      <h2>In the last 30 days 10Web had:</h2>
      <div class="db-migration-benefits mt10" [ngClass]="{'mt15': !!isMobile}">
        <div>
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>99.9%</b> uptime </p>
        </div>
        <div class="mt8">
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>30K+</b> prevented security issues </p>
        </div>
        <div class="mt8">
          <div class="db-migration-benefit-count mr8">
            <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
          </div>
          <p class="db-migration-benefit-desc"> <b>97.6%</b> customer support satisfaction rate </p>
        </div>
      </div>
    </div>
    <div class="db-migration-success-dialog__buttons-wrap mt32">
      <button class="ds-btn-black" (click)="close()">Explore & Test</button>
    </div>
  </div>
  <div class="db-migrate-website__image-section" *ngIf="!isMobile">
    <div>
      <div class="db-migration-success-dialog__preview-thumbnail"
           [ngStyle]="{
               'background-color': 'rgba(0, 0, 0, 0.1)',
               'background-image': 'url(&quot;'+ ('data:image/jpg;base64,' + websiteScreenshot) + '&quot;)',
               'background-size': 'cover'
               }">
      </div>
      <div class="db-migration-success-dialog__preview-site-info">
        <div class="mt20">
          <p class="db-migration-success-dialog__subtitle">Your website URL</p>
          <a target="_blank" rel="noopener" href="{{siteUrl}}" class="db-migration-success-dialog__link">
            <span [innerHTML]="siteUrl"></span><i class="db-icon db-icon-external-n"></i>
          </a>
        </div>
        <div class="mt20">
          <p class="db-migration-success-dialog__subtitle">Location/data center</p>
          <p class="db-migration-success-dialog__location" [innerText]="hostingInfoData?.hostingBasicInfo?.location"></p>
        </div>
      </div>
    </div>
    <div class="db-migration-success-dialog__fastest" >
      <p>Your website is now in the top<br/> <b>1% fastest websites</b> of the world․</p>
      <img src="assets/images/google/google-partner-transparent.svg" alt="">
    </div>
  </div>
</div>
